import * as React from 'react';
import {StatelessComponent  } from 'react';
import {Select, ISelectOption} from '../../select/select';
import {VideoSettingsLabel as Label} from '../label/label';
import {VIDEO_QUALITY} from './constants';

interface IVideoSettingsVideoQualityProps {
  videoQualityId: string;
  hidden: boolean;
  error: string;
  onChange: (params: ISelectOption) => void;
}

export const VideoSettingsVideoQuality: StatelessComponent<IVideoSettingsVideoQualityProps> = ({
  videoQualityId,
  hidden,
  error,
  onChange,
}) => {
  if (hidden) {
    return null;
  }

  return (
    <div>
      <Label>Video Quality</Label>

      <Select
        options={VIDEO_QUALITY}
        value={videoQualityId}
        onChange={onChange}
      />
    </div>
  );
};
